import { useEffect } from "react";

import useServicesButtonActions from "../../hooks/useServicesButtonActions";
import { useServicesStore } from "../../store/services-provided/servicesStore";
import STRINGS from "../../utils/strings";
import CancelButton from "../buttons/CancelButton";
import SaveButton from "../buttons/SaveButton";

export default function ActionButtons() {
  const {
    servicesToBeAdded,
    servicesToBeRemoved,
    disableCancelBtn,
    setDisableCancelBtn,
    disableSaveBtn,
    setDisableSaveBtn,
  } = useServicesStore();
  const { handleOnClickCancelButton, handleOnClickSaveButton } = useServicesButtonActions();

  useEffect(() => {
    if (servicesToBeAdded.length > 0 || servicesToBeRemoved.length > 0) {
      setDisableCancelBtn(false);
      setDisableSaveBtn(false);
    } else {
      setDisableCancelBtn(true);
      setDisableSaveBtn(true);
    }
  }, [servicesToBeAdded, servicesToBeRemoved, setDisableCancelBtn, setDisableSaveBtn]);

  return (
    <div className="flex w-1/2 flex-row justify-end gap-2 px-2 py-2">
      <CancelButton
        className="w-1/2"
        disabled={disableSaveBtn}
        onClick={handleOnClickCancelButton}
      />
      <SaveButton
        className="w-1/2"
        disabled={disableCancelBtn}
        onClick={handleOnClickSaveButton}
        label={STRINGS.BUTTON_LABELS.SAVE}
      />
    </div>
  );
}
